import { Icon, Text, Tooltip } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  open: boolean
  toggle: (value: boolean) => () => void
}

const MessagesTooltip = ({ toggle, open }: Props) => {
  return (
    <Tooltip.ItemList toggle={toggle} attachment="top center" open={open} size="normal">
      <Icon.Medium icon="info-circle-line" color="grey800" />
      <Text.Normal>{i18n.t('incidences.header.messages_tooltip')}</Text.Normal>
    </Tooltip.ItemList>
  )
}

export default MessagesTooltip
